import React from 'react'
class CurrentYear extends React.Component{
    
    render(){
        return <span>{(new Date().getFullYear())}</span>
    }
}

export default CurrentYear